var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 107,
    viewBox: "0 0 128 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector element 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1433 31.5588C45.4447 31.223 56.7082 30.7843 60.7699 37.0772C60.7699 37.0772 59.6248 43.9078 55.9595 52.4897C53.1399 59.0916 48.6057 66.5457 43.3223 73.8532C32.6109 88.6684 10.7097 107 10.7097 107L38.1433 31.5588Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3181 31.2054C61.3181 48.4397 47.5916 62.4109 30.6591 62.4109C13.7265 62.4109 0 48.4397 0 31.2054C0 13.9712 13.7265 0 30.6591 0C47.5916 0 61.3181 13.9712 61.3181 31.2054Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.825 31.5588C112.127 31.223 123.39 30.7843 127.452 37.0772C127.452 37.0772 126.307 43.9078 122.641 52.4897C119.822 59.0916 115.288 66.5457 110.004 73.8532C99.2928 88.6684 77.3917 107 77.3917 107L104.825 31.5588Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 31.2054C128 48.4397 114.273 62.4109 97.341 62.4109C80.4085 62.4109 66.682 48.4397 66.682 31.2054C66.682 13.9712 80.4085 0 97.341 0C114.273 0 128 13.9712 128 31.2054Z",
    fill: "#EAEAEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.af5dfba234929b16c9500f00a955e55e.svg";
export { ForwardRef as ReactComponent };